<template>
    <!-- Encabezado de la Aplicación -->
    <div class="appHeader">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Páginas
        </div>
        <div class="right">
        </div>
    </div>
    <!-- * Encabezado de la Aplicación -->

    <!-- Cápsula de la Aplicación -->
    <div id="appCapsule">
        <div class="listview-title mt-1">Páginas de la aplicación</div>
        <ul class="listview image-listview inset mb-2">
            <li>
                <a href="/transactions" class="item">
                    <div class="icon-box bg-primary">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Transacciones
                    </div>
                </a>
            </li>
            <!-- <li>
                <a href="/transaction-detail" class="item">
                    <div class="icon-box bg-primary">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Detalle de la transacción
                    </div>
                </a>
            </li> -->
            <!-- <li>
                <a href="/transaction-verification" class="item">
                    <div class="icon-box bg-primary">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Verificación de transacción
                    </div>
                </a>
            </li> -->
            <li>
                <a href="/notifications" class="item">
                    <div class="icon-box bg-primary">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Notificaciones
                    </div>
                </a>
            </li>
            <!-- <li>
                <a href="/notification-detail.php" class="item">
                    <div class="icon-box bg-primary">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Detalle de la notificación
                    </div>
                </a>
            </li> -->
            <li>
                <a href="/settings" class="item">
                    <div class="icon-box bg-primary">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Ajustes
                    </div>
                </a>
            </li>
        </ul>

        <div class="listview-title">Criptomonedas</div>
        <ul class="listview image-listview inset mb-2">
            <li>
                <a href="/crypto/index" class="item">
                    <div class="icon-box bg-info">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Inicio
                    </div>
                </a>
            </li>
            <!-- <li>
                <a href="crypto-coin-detail.php" class="item">
                    <div class="icon-box bg-info">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Detalle de la moneda
                    </div>
                </a>
            </li> -->
            <li>
                <a href="/crypto/exchange" class="item">
                    <div class="icon-box bg-info">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Intercambio
                    </div>
                </a>
            </li>
            <li>
                <a href="/crypto/portfolio" class="item">
                    <div class="icon-box bg-info">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Portafolio
                    </div>
                </a>
            </li>
            <li>
                <a href="/crypto/transactions" class="item">
                    <div class="icon-box bg-info">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Transacciones
                    </div>
                </a>
            </li>
        </ul>

        <div class="listview-title">Tema</div>
        <ul class="listview image-listview inset mb-2">
            <li>
                <div class="item">
                    <div class="icon-box bg-primary">
                        <ion-icon name="moon-outline"></ion-icon>
                    </div>
                    <div class="in">
                        <div>Modo oscuro</div>
                        <div class="form-check form-switch  ms-2">
                            <input class="form-check-input dark-mode-switch" type="checkbox" id="darkmodeSwitch">
                            <label class="form-check-label" for="darkmodeSwitch"></label>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <div class="listview-title">Otros</div>
        <ul class="listview image-listview inset mb-3">
            <li>
                <a href="/about" class="item">
                    <div class="icon-box bg-success">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Acerca de la página
                    </div>
                </a>
            </li>
            <li>
                <a href="/contact" class="item">
                    <div class="icon-box bg-success">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Contacto
                    </div>
                </a>
            </li>
            <li>
                <a href="/faq" class="item">
                    <div class="icon-box bg-success">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Preguntas frecuentes
                    </div>
                </a>
            </li>
            <li>
                <a href="/404" class="item">
                    <div class="icon-box bg-success">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        404
                    </div>
                </a>
            </li>
            <li>
                <a href="/splash" class="item">
                    <div class="icon-box bg-success">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Icono de inicio
                    </div>
                </a>
            </li>
            <!-- <li>
                <a href="/splash-image" class="item">
                    <div class="icon-box bg-success">
                        <ion-icon name="cube-outline"></ion-icon>
                    </div>
                    <div class="in">
                        Imagen de inicio
                    </div>
                </a>
            </li> -->
        </ul>
    </div>
    <!-- * Cápsula de la Aplicación -->
    <default-button-menu />
</template>

<script>
export default {
    data() {
        return {
        };
    },
    mounted() {
        let self = this
        self.$root.loadBackButtom();

        
        var pageBody = document.querySelector("body");
        var switchDarkMode = document.querySelectorAll(".dark-mode-switch");

        function switchDarkModeCheck(value) {
            switchDarkMode.forEach(function (el) {
                el.checked = value
            })
        }
        switchDarkMode.forEach(function (el) {
            el.addEventListener("click", function () {
                var darkmodeCheck = localStorage.getItem("FinappDarkmode");
                var bodyCheck = pageBody.classList.contains('dark-mode');
                if (darkmodeCheck === 1 || darkmodeCheck === "1" || bodyCheck) {
                    pageBody.classList.remove("dark-mode");
                    localStorage.setItem("FinappDarkmode", "0");
                    switchDarkModeCheck(false);
                }
                else {
                    pageBody.classList.add("dark-mode")
                    switchDarkModeCheck(true);
                    localStorage.setItem("FinappDarkmode", "1");
                }
            })
        })
    },
    methods: {
    }
}
</script>